module.exports = __webpack_public_path__ + "img/popup-top-gt.fab26b1.png";